import { WireTypes } from "@flakiness/server/common/wireTypes.js";
import { markdown } from "../markdown.js";
import { ciTabs } from "./welcome_ci_tabs.js";
import { accessToken } from "./welcome_new_project.js";

const ghaOIDCInstructions = () => markdown`
  Enable the \`id-token: write\` permission in your workflow:

  ${markdown.yaml(`
    permissions:
      contents: read # Required for actions/checkout
      id-token: write # Required for GitHub OIDC

    steps:
      - uses: actions/checkout@v4
      - name: Run Cucumber tests
        run: npx cucumber-js
  `, `.github/workflows/cucumber.yml`, { ins: [[1, 3]] })}
`;

const gitlabOIDCInstructions = (project: WireTypes.Project) => markdown`
  GitLab mints the ID token when the job starts, so declare one named \`FLAKINESS_ID_TOKEN\` with your project as its audience:

  ${markdown.yaml(`
    test:
      id_tokens:
        FLAKINESS_ID_TOKEN:
          aud: ${project.org.orgSlug}/${project.projectSlug} # Required for GitLab OIDC
      script:
        - npx cucumber-js
  `, `.gitlab-ci.yml`, { ins: [[2, 4]] })}
`;

const otherCIInstructions = (project: WireTypes.Project) => markdown`
  Set the \`FLAKINESS_ACCESS_TOKEN\` environment variable to ${accessToken(project)} and run your tests:

  ${markdown.bash(`
    FLAKINESS_ACCESS_TOKEN=<token> npx cucumber-js
  `)}
`;

export const welcome_cucumberjs = (project: WireTypes.Project) => markdown`

1. Install the Flakiness.io CucumberJS formatter:

    ${markdown.bash(`
      npm i -D @flakiness/cucumberjs
    `)}

1. Add the Flakiness.io formatter to your \`cucumber.mjs\` configuration file:

    ${markdown.js(`
      export default {
        default: {
          format: ['@flakiness/cucumberjs'],
          formatOptions: {
            flakinessProject: '${project.org.orgSlug}/${project.projectSlug}',
          },
        },
      };
    `, `cucumber.mjs`, { ins: [[3, 6]] })}

1. Configure your CI
    ${ciTabs({
      idPrefix: 'cjs',
      project,
      githubActions: ghaOIDCInstructions(),
      gitlabCI: gitlabOIDCInstructions(project),
      otherCI: otherCIInstructions(project),
    })}
`;
